import React, { Component, Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';

import { ApiHelper } from '../../helpers/ApiHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../helpers/Helper';
import { BaseEntityPage } from '../BaseEntityPage';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { Button, Grid } from '@material-ui/core';
import { TableComponent } from '../TableComponent';
import { OptionsSubEntityComponent } from './OptionsSubEntityComponent';
import { AppConfig } from '../../../AppConfig';

export class Questions extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageTitle = 'Questions'
    this.quizId = this.props.match.params.quizId
    this.secId = this.props.match.params.secId
    this.groupId = 'sec' + this.quizId
    this.subId = this.props.match.params.subId
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: 'Sections', to: '/admin/quiz/' + this.quizId },
      { title: 'Subsection', to: '/admin/quiz/' + this.quizId + '/' + this.secId },
      { title: 'Questions' },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['items', this.subId], { groupId: this.groupId }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['questions'],
        { pb: 'fieldDef,fieldDefQuestionGroup,fieldDefOptions,fieldDefNoTagOptions,fieldDefQuestionAction', groupId: this.subId }) },
    ]
    this.headerActions = [{
      label: 'Add Question Group',
      onClick: () => this.openModalForAdd('groups')
    }]
    this.tableHeadersMap = {
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.id + ' / ' + current.order}</span>
            <br />
            <span className={css(Styles.spanLabel)}>Type: </span>
            <span className={css(Styles.spanValue)}>{QuestionTypes[current.type].label}</span>
            <br />
            <span className={css(Styles.spanValue)}>Other {current.otherAllowed ? '(Yes)' : '(No)'}</span>
            <span className={css(Styles.spanValue)}> Options {current.options ?
              '(' + Object.keys(current.options).length + ')' : '(No)' }</span>
            <span className={css(Styles.spanValue)}> Jumps {
              '(' + Object.keys(current.options).map(k => current.options[k].tag ? 1 : 0).reduce((a, b) => a + b, 0) + ')' }</span>
            <br />
            {current.tableNum &&
            <span className={css(Styles.spanLabel)}>Table: {current.tableNum}</span>
            }
          </div>
        )
      },
      question: (current) => current.title,
    }
    this.apiData = {
      quizId: this.quizId,
      groupId: this.subId
    }
    this.cellWidths = {
      '    ': Styles.details,
      question: Styles.question
    }

    const self = this
    this.subEntities = {
      options: {
        apiPath: 'questions',
        queryParams: {},
        tableHeadersMap: {
          option: (current) => current.title,
          'jump to group': (current) => {
            if (!current.tag) {
              return ''
            }
            if (self.state.subSection.groups[current.tag]) {
              return self.state.subSection.groups[current.tag].title
            }
            return ''
          },
          order: (current) => current.order,
        }
      }
    }

    this.tables = {
      groups: {
        subEntity: true,
        fieldDef: 'fieldDefQuestionGroup',
        apiPath: 'items',
        queryParams: { groupId: this.groupId },
      }
    }
    // this.SubEntityComponent = OptionsSubEntityComponent
  }

  getEntityProps(current, entityAttrName) {
    const entityProps = super.getEntityProps(current, entityAttrName)
    if (current.type === 'YESNO') {
      entityProps.noDelete = true
      entityProps.noAdd = true
    }
    entityProps.pageTitle = entityAttrName
    entityProps.renderAboveTable = this.renderAboveOptionsTable
    if(current.tag) {
      entityProps.formDefinition = this.state.questions.fieldDefNoTagOptions
    }
    return entityProps
  }

  onFetchSuccess(results) {
    const subSection = results[0]
    const questions = results[1]
    this.formDefinition = questions.fieldDef;
    this.fieldDefQuestionAction = questions.fieldDefQuestionAction
    const tagQuestionsMap = {}
    const noTagQuestions = []
    questions.items.forEach(question => {
      if (question.tag) {
        const tagQuestions = tagQuestionsMap[question.tag] || []
        tagQuestions.push(question)
        tagQuestionsMap[question.tag] = tagQuestions
      } else {
        noTagQuestions.push(question)
      }
    })
    this.subEntities.options.formDefinition = questions.fieldDefOptions
    const tagOptions = [{id: '', title: 'No Branch'}, ...Object.values(subSection.groups)]
    AppHelper.populateOptions(questions.fieldDefOptions, { items: tagOptions }, 'tag')
    this.tables.groups = questions.fieldDefQuestionGroup
    const groups = subSection.groups || {}
    this.pageTitle = subSection.title
    this.setState({
      subSection: subSection,
      questions: questions,
      groups: Object.values(groups),
      tagQuestionsMap: tagQuestionsMap,
      items: noTagQuestions
    })
  }

  renderAboveOptionsTable(entityComponentState) {
    return (
      <div className={css(Styles.tableHeadingContent)}>
        <Grid container className={css(Styles.containerNarrow)}>
          <Grid item sm={12} xs={12}>
            <h2 className={css(Styles.heading)}>{entityComponentState.entityItem.title}</h2>
          </Grid>
        </Grid>
      </div>
    )
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.tableHeadingContent)}>
        <Grid container className={css(Styles.containerNarrow)}>
          <Grid item sm={6} xs={6}>
            <h2 className={css(Styles.heading)}>{'Questions'}</h2>
          </Grid>
          <Grid item sm={6} xs={6} className={css(Styles.containerButton)}>
            <Button
              className={css(Styles.button)}
              variant='contained' color='primary' onClick={() => this.openModalForAdd()}>
              <i className='material-icons'>add_circle_outline</i>
              <span className={css(Styles.buttonLabel)}>{'Add Question'}</span>
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  renderBelowTable() {
    return (
      <Fragment>
        <div className={css(Styles.tableHeadingContent)}>
          {this.state.groups.map(group => this.renderQuestionGroup(group))}
        </div>
      </Fragment>
    );
  }

  renderAboveGroupTable(group) {
    return (
      <div className={css(Styles.tableHeadingContent)}>
        <Grid container className={css(Styles.containerNarrow)}>
          <Grid item sm={6} xs={6} className={css(Styles.groupEdit)}>
            <h2 className={css(Styles.heading)}>{group.title}</h2>
            <p className={css(Styles.subheading)}>{'Question Group'}</p>
            <Tooltip title='Edit' placement='top-start' key={group.id + 'editTT'}>
              <span className={css(AppStyles.entityTableLinkIcon)}>
                <i className='material-icons' onClick={() => this.openModalForEdit(group, 'groups')}>edit</i>
              </span>
            </Tooltip>
            <Tooltip title='Delete' placement='top-start' key={group.id + 'delTT'}>
              <span className={css(AppStyles.entityTableLinkIcon)}>
                <i className='material-icons' onClick={() => this.openModalForDelete(group, 'groups')}>delete</i>
              </span>
            </Tooltip>
          </Grid>
          <Grid item sm={6} xs={6} className={css(Styles.containerButton)}>
            <Button
              className={css(Styles.button)}
              variant='contained' color='primary' onClick={() => this.openModalForAdd('groupQuestion', group)}>
              <i className='material-icons'>add_circle_outline</i>
              <span className={css(Styles.buttonLabel)}>{'Add Question'}</span>
            </Button>
          </Grid>
        </Grid>
      </div>
    )
  }

  renderQuestionGroup(group) {
    const { tagQuestionsMap } = this.state
    const groupQuestions = tagQuestionsMap[group.id] || []
    return (
      <div className={css(Styles.entityContainer)} key={'group-' + group.id}>
        <div className={css(Styles.row)}>
          {this.renderAboveGroupTable(group)}
        </div>
        <div className={css(Styles.row)}>
          {this.renderGroupTable(group, groupQuestions)}
        </div>
      </div>
    )
  }

  renderGroupTable(group, groupQuestions) {
    // console.log(group, groupQuestions)
    return (
      <TableComponent
        tableHeadersMap={this.tableHeadersMap}
        items={groupQuestions}
        setItems={this.setItems.bind(this)}
        headerActions={this.headerActions} //Multi checkbox
        onActions={this.onActions.bind(this)}
        nextPage={this.state.nextPage}
        nextPageState={this.state.nextPageState}
        onNext={this.onNext.bind(this)}
        emptyText={'Add questions to this group'}
        cellWidths={this.cellWidths}
      />
    )
  }

  openModalForAdd(form, group) {
    if (form === 'groups') {
      this.formDefinition = this.state.questions.fieldDefQuestionGroup
    } else {
      this.formDefinition = this.state.questions.fieldDef
    }
    this.form = form
    this.group = group
    super.openModalForAdd()
  }

  onAdd() {
    let tag = ''
    if (this.form === 'groupQuestion') {
      tag = this.group.id
    }
    if (this.form === 'groups') {
      this.setState({
        apiMethod: 'PUT',
        apiData: { entityAction: 'add', entityAttrName: 'groups' },
        apiEndPoint: ApiHelper.makeUrlPath(['items', this.subId], { groupId: this.groupId }),
      })
    } else {
      this.setState({
        apiMethod: 'POST',
        apiData: { quizId: this.quizId, groupId: this.subId, tag: tag},
        apiEndPoint: ApiHelper.makeUrlPath(['questions'], {}),
      });
    }
  }

  openModalForEdit(current, form) {
    if (form === 'groups') {
      this.formDefinition = this.state.questions.fieldDefQuestionGroup
    } else {
      this.formDefinition = this.state.questions.fieldDef
    }
    this.form = form
    this.group = current
    super.openModalForEdit(current)
  }

  openModalForActionEdit(current) {
    this.formDefinition = this.fieldDefQuestionAction
    super.openModalForEdit(current, this.fieldDefQuestionAction)
  }

  openModalForDelete(current, form, group) {
    if (form === 'groups') {
      this.formDefinition = this.state.questions.fieldDefQuestionGroup
    } else {
      this.formDefinition = this.state.questions.fieldDef
    }
    this.form = form
    this.group = group
    super.openModalForDelete(current)
  }

  onEdit(current) {
    if (this.form === 'groups') {
      this.setState({
        apiMethod: 'PUT',
        apiData: { entityAction: 'edit', entityAttrName: 'groups', id: current.id },
        apiEndPoint: ApiHelper.makeUrlPath(['items', this.subId], { groupId: this.groupId }),
      })
    } else {
      this.setState({
        apiMethod: 'PUT',
        apiData: { groupId: this.subId},
        apiEndPoint: ApiHelper.makeUrlPath(['questions', current.id], {}),
      })
    }
  }

  onDelete(current) {
    if (this.form === 'groups') {
      this.setState({
        apiMethod: 'PUT',
        apiData: { entityAction: 'del', entityAttrName: 'groups', id: current.id },
        apiEndPoint: ApiHelper.makeUrlPath(['items', this.subId], { groupId: this.groupId }),
      })
    } else {
      this.setState({
        apiMethod: 'DELETE',
        apiData: { groupId: this.subId},
        apiEndPoint: ApiHelper.makeUrlPath(['questions', current.id], {}),
      })
    }
  }

  showOptionsAction(current) {
    const { type } = current
    return type === 'OPTIONS-MUL' || type === 'OPTIONS-SINGLE' || type === 'YESNO'
  }

  onActions (current) {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    this.showOptionsAction(current) && actions.push(
      <Tooltip title='Options' placement='top-start' key={current.id + '-options'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => this.switchSubView(current, 'options')}>format_list_numbered</i>
        </span>
      </Tooltip>
    )
    actions.push(
      <Tooltip title='Actions' placement='top-start' key={current.id + '-actions'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => this.openModalForActionEdit(current)}>spellcheck</i>
        </span>
      </Tooltip>
    )
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }
}

const QuestionTypes = {
  YESNO: { key: 'YESNO', label: 'Yes/No', value: false },
  'OPTIONS-MUL': { key: 'OPTIONS-MUL', label: 'Options - Multiple Answers', value: false },
  'OPTIONS-SINGLE': { key: 'OPTIONS-SINGLE', label: 'Options - Single Answer', value: false },
  'TEXT-SHORT': { key: 'TEXT-SHORT', label: 'Short Answer', value: false },
  'TEXT-PARA': { key: 'TEXT-PARA', label: 'Long Answer', value: false },
  DATE: { key: 'DATE', label: 'Date', value: false },
  INT: { key: 'INT', label: 'Integer Number', value: false },
  FLOAT: { key: 'FLOAT', label: 'Decimal Number', value: false },
  TIME: { key: 'TIME', label: 'Time', value: false },
  'LABEL-BOLD': { key: 'LABEL-BOLD', label: 'Label Bold', value: false },
  LABEL: { key: 'TILABELME', label: 'Label', value: false }
}

const Styles = StyleSheet.create({
  tableHeadingContent: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: AppTheme.viewPort,
    width: '100%',
    paddingTop: 20
  },
  containerNarrow: {
    maxWidth: AppTheme.viewPort
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  heading: {
    margin: 8,
    marginLeft: 0,
    marginRight: 6,
    // display: 'inline'
  },
  subheading: {
    fontSize: 10,
    textTransform: 'uppercase',
    margin: 8,
    marginLeft: 0,
    marginRight: 6,
    // display: 'inline'
  },
  button: {
    boxShadow: 'none',
    marginLeft: 10
  },
  buttonLabel: {
    marginLeft: 4
  },
  entityContainer: {
    marginTop: -AppTheme.toolbarHeight,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    backgroundColor: AppTheme.primaryBg
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  spanLabel: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  spanValue: {
    fontSize: 12
  },
  details: {
    width: '25%'
  },
  question: {
    width: '65%'
  },
  groupEdit: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/common/components/quizcreator/Questions.js